import React, {useEffect, useState} from "react";
import Utils from "../../../utils";
import {toast} from "react-toastify";
import {postCreditHistory} from "../../../services/BilingService";
import Pagination from "react-js-pagination";
import "./Billing.css";

const lengths = Utils.tableShowLengths();

function CreditHistory() {

    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(1);
    const [list, setList] = useState([]);
    const [totalHistory, setTotalHistory] = useState(0);
    const [listProcess, setListProcess] = useState('loading...');

    const handleTableLength = (e) => {
        setPage(1);
        setLimit(parseInt(e.target.value));
    };

    useEffect(function () {

        setListProcess('loading...');
        postCreditHistory({limit: limit, page: page})
            .then(response => {
                setList(response.data.list);

                if (response.data.list.length === 0) {
                    setListProcess('No data available.');
                }

                setTotalHistory(parseInt(response.data.count));
            })
            .catch(err => {
                setListProcess('No data available.');
                toast.error(Utils.getErrorMessage(err));
            });

    }, [limit, page]);

    return (
        <div className="billing-container" id="preferences" role="tabpanel"
             aria-labelledby="preferences-tab">
            <h2 className="billing-page-title mb-3">Credit History</h2>
            <div className="billing-card">
                <div className="overflow-x-scroll">
                    <table className="table billing-table mb-0">
                        <thead>
                        <tr>
                            <th className="ps-4" style={{width: '10%'}}>Sleeves Name</th>
                            <th style={{width: '14.70%'}}>Created By</th>
                            <th style={{width: '8.70%'}}>Plan Name</th>
                            <th style={{width: '8.22%'}}>Date</th>
                            <th style={{width: '12.5%', textAlign: 'center'}}>Sleeves Credits Left</th>
                            <th style={{width: '12.5%', textAlign: 'center'}}>Sleeves Credits Used</th>
                            <th style={{width: '12.5%', textAlign: 'center'}}>SMS <br/> Credits Left (Plan)</th>
                            <th style={{width: '12.5%', textAlign: 'center'}}>SMS <br/> Credits Left (Add-ons)</th>
                            <th style={{width: '12.5%', textAlign: 'center'}}>SMS <br/>Credits Used</th>
                        </tr>
                        </thead>
                        <tbody>
                        {list && list.map((item, index) =>
                            <tr key={index}>
                                <td className="ps-4">{item.envelope_name}</td>
                                <td>{item.sender_name}</td>
                                <td>{item.plan_name}</td>
                                <td>{item.created_at}</td>
                                <td className="text-center">
                                    <span className="credit-badge-left">{item.envelope_left}</span>
                                </td>
                                <td className="text-center">
                                    <span className="credit-badge-used">{item.envelope_used}</span>
                                </td>
                                <td className="text-center">
                                    <span className="credit-badge-left">{item.sms_left}</span>
                                </td>
                                <td className="text-center">
                                    <span className="credit-badge-left">{item.sms_add_on_left}</span>
                                </td>
                                <td className="text-center">
                                    <span className="credit-badge-used">{item.sms_used}</span>
                                </td>
                            </tr>
                        )}

                        {list.length === 0 &&
                        <tr>
                            <td className="text-center" colSpan={9}>{listProcess}</td>
                        </tr>
                        }
                        </tbody>
                    </table>
                </div>
                
            </div>
            <div className="billing-pagination-container pb-3">
                    <div className="d-flex align-items-center">
                        <span className="me-2 text-white">Show</span>
                        <select className="form-select show-entries-select" aria-label="Default select example" value={limit}
                                onChange={handleTableLength}>
                            {lengths && lengths.map((item, i) => <option value={item} key={i}>{item}</option>)}
                        </select>
                    </div>
                    <div className="pagination-wrapper">
                        <Pagination
                            activePage={page}
                            itemsCountPerPage={limit}
                            totalItemsCount={totalHistory}
                            pageRangeDisplayed={5}
                            onChange={(e) => setPage(e)}
                            itemClass="page-item"
                            linkClass="page-link"
                            prevPageText="‹"
                            nextPageText="›"
                            firstPageText="«"
                            lastPageText="»"
                        />
                    </div>
                </div>
        </div>
    );
}

export default CreditHistory;